const setOrgData = (state, payload) => {
  state.orgData = payload
}

const updateTotal = (state, payload) => {
  state.total = payload
}

const setSelectedOrg = (state, payload) => {
  state.selectedOrg = payload
}

const setOrgFlags = (state, payload) => {
  state.orgFlags = payload
}

const setOrgFlagsFetched = (state, payload) => {
  state.orgFlagsFetched = payload
}

const updateOrgFeatures = (state, payload) => {
  const featureIndex = state.orgFeatures.findIndex(f => f.feature === payload.feature)
  if (featureIndex !== -1) state.orgFeatures[featureIndex] = payload
  else state.orgFeatures.push(payload)
}

const setOrgFeaturesFetched = (state, payload) => {
  state.orgFeaturesFetched = payload
}

export default {
  updateTotal,
  setSelectedOrg,
  setOrgData,
  setOrgFlags,
  setOrgFlagsFetched,
  updateOrgFeatures,
  setOrgFeaturesFetched,
}
